import React from "react";
import { useTranslation } from "react-i18next";
import { formatToLocalDateTime } from "../utils/formatDate";
import Loader from "../../../components/Loader";
import edit from "../../../assets/edit.png";

interface AdminTableProps {
  tableData: any;
  loading: boolean;
  handleEditCustomer: (id: string) => void;
}
const CustomerTable: React.FC<AdminTableProps> = ({
  tableData,
  loading,
  handleEditCustomer,
}) => {
  const { t } = useTranslation();
  return (
    <div className="h-[70vh] md:h-[67vh] overflow-auto page-container p-2 pt-0 scrollbar scrollbar-thin">
      <table className="min-w-full bg-white border border-black-200 table-auto border-separate border-spacing-0">
        <thead className="bg-gray-200 sticky top-[0px] z-20">
          <tr>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-nowrap">
              Channel ID
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              Channel Name
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
              City
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              District
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              Division ID
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              Division Name
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              House Number
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              Latitude
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              Longitude
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              Mobile Number
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              B2B Mobile Number
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              Outlet ID
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              Outlet Name (Arabic)
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              Outlet Name (English)
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              Payer ID
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              Payment Term ID
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              Payment Term Name
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              Postal Code
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              Sales Office ID
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              Sales Office Name
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              Status
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              Created At
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              VAT
            </th>
            <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500">
              Edit
            </th>
          </tr>
        </thead>
        {loading ? (
          <tbody>
            <tr>
              <td colSpan={16} className="py-8">
                <div className="flex justify-center items-center w-full">
                  <Loader />
                </div>
              </td>
            </tr>
          </tbody>
        ) : !loading && tableData?.items?.length === 0 ? (
          <tr>
            <td colSpan={16} className="py-8 text-center text-gray-500">
              No results found
            </td>
          </tr>
        ) : (
          <tbody>
            {Array.isArray(tableData?.items) &&
              tableData.items.map((item: any, index: number) => (
                <tr key={index} className="border-b text-sm">
                  <td className="border border-gray-300 px-4 py-2">{item.channel_id || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.channel_name || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.city || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.district || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.division_id || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.division_name || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.house_no || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.latitude || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.longitude || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.mobile_number || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.b2b_mobile || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.outlet_id || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.outlet_name_ar || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.outlet_name_en || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.payer_id || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.payment_term_id || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.payment_term_name || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.postcode || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.sales_office_id || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.sales_office_name || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">{item.status || "-"}</td>
                  <td className="border border-gray-300 px-4 py-2">
                    {formatToLocalDateTime(item.created_at)}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">{item.vat || "-"}</td>
                  <td
                    onClick={() => handleEditCustomer(item.outlet_id)}
                    className="border border-gray-300 px-4 py-2 cursor-pointer"
                  >
                    <img className="w-4" src={edit} alt="edit" />
                  </td>
                </tr>
              ))}
          </tbody>
        )}
      </table>
    </div>
  );
};

export default CustomerTable;
